var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Search-/-Uploading",
    transform: "translate(-20.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Uploading",
    transform: "translate(20.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Circle",
    fill: "#E67F45",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glyphs-/-Sync",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C16.078125,4 19.4375,7.054688 19.929688,11 L15,10 L16.386719,7.917969 C15.292969,6.742188 13.734375,6 12,6 C9.089844,6 6.683594,8.078125 6.136719,10.824219 L4.167969,10.425781 C4.898438,6.761719 8.121094,4 12,4 Z M12,20 C7.921875,20 4.5625,16.945312 4.070312,13 L9,14 L7.613281,16.082031 C8.707031,17.257812 10.265625,18 12,18 C14.910156,18 17.316406,15.921875 17.863281,13.175781 L19.832031,13.574219 C19.101562,17.238281 15.878906,20 12,20 Z",
    id: "Colors"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploading);
export default __webpack_public_path__ + "static/media/uploading.93516b108fa8639286040f57b98f26ad.svg";
export { ForwardRef as ReactComponent };